import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export interface User {
  email: string;
  token?: string;
  name?: string;
  id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  errorMessage = '';
  userSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);

  private loginUrl = `${environment.apiUrl}/auth/login`;
  private logoutUrl = `${environment.apiUrl}/auth/logout`;

  constructor(
    private http: HttpClient,
    private routes: Router
  ) {
    const userTokenStr = localStorage.getItem('user_token') || '';
    if (userTokenStr) {
      // Simple token check without JWT decoding
      this.userSubject.next({ email: '', token: userTokenStr });
    }
  }

  checkusernameandpassword(email: string, password: string, logAs?: string): Observable<User> {
    email = email.trim();
    let params: any = { email: email, password: password };
    if (logAs) params.logas = logAs;

    return new Observable(observer => {
      this.http.post<any>(this.loginUrl, params).subscribe({
        next: (res: any) => {

          // Handle both direct user response and wrapped response
          let data = res.user || res.payload || res;

          if (data && data.email && data.email.toLowerCase() === email.toLowerCase()) {
            this.userSubject.next(data);
            observer.next(data);
          } else {
            observer.error({ status: 400, message: 'Invalid response' });
          }
        },
        error: err => {
          observer.error(err);
        }
      });
    });
  }

  logout() {
    localStorage.removeItem('user_token');
    this.userSubject.next(null);
    this.routes.navigate(['/login']);
  }
}